const NODE_ID_STATE = Symbol.for('@smoothie-framework/ui.node-id-state');
function nodeIdState() {
    const host = globalThis;
    const current = host[NODE_ID_STATE];
    if (current)
        return current;
    const created = { value: 0 };
    host[NODE_ID_STATE] = created;
    return created;
}
export function createNodeId() {
    const state = nodeIdState();
    state.value += 1;
    return `node_${state.value}`;
}
//# sourceMappingURL=node-id.js.map